import { ApiErrorCode, withApiErrorHandler } from '@/modules/common/api/errors';
import { axiosInstance } from '@/utils/axios';

export interface AccountIdResponse {
  accountId: string;
}

export const getAccountId = async (): Promise<string> => {
  const endpoint = '/api/integrations/google/connect';

  const data = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.ONBOARDING_GOOGLE_ACCOUNT_ID_FAILED,
    () => axiosInstance.post(endpoint)
  );

  return (data as AccountIdResponse).accountId;
};

export interface ConnectRequest {
  email: string;
}

export const connect = async (data: ConnectRequest): Promise<void> => {
  const endpoint = '/api/integrations/google/connect';

  await withApiErrorHandler(endpoint, ApiErrorCode.ONBOARDING_GOOGLE_CONNECT_FAILED, () =>
    axiosInstance.patch(endpoint, data)
  );
};
